import getColor from './getColor'
import getTextColor from './getTextColor'

export default [getColor, getTextColor]
